const DonutChart = ({
  id = "",
  data,
  width,
  height,
  style = { pointerEvents: "all" },
}) => {
  const fillColor = data.isInAlarm ? "#FB0004" : "#20ac20 ";

  return (
    <svg id={id} width={width} height={height} style={style}>
      <circle cx={width / 2} cy={height / 2} r={height / 2} fill={fillColor} />
    </svg>
  );
};

export default DonutChart;
